import React, { useEffect, useState } from 'react';
import api from '../../services/api';
import { messaggioDa, notificaErrore } from '../../utils/notifiche';

/**
 * MiaEstrazioneEsami — l'opzione «Estrazione automatica degli esami» del
 * medico collegato (migration 267), nel suo profilo. La stessa colonna che
 * l'amministrazione cambia dal modulo del medico: una sola, e ogni cambio
 * sta nel registro modifiche.
 *
 * Accesa: un referto di laboratorio caricato per questo medico viene letto
 * da solo. L'estrazione non conferma niente: i valori restano «da
 * verificare» finché il medico non li guarda.
 */
const MiaEstrazioneEsami = () => {
    const [attiva, setAttiva] = useState(null);
    const [inCorso, setInCorso] = useState(false);

    useEffect(() => {
        api.get('/medici/mia-estrazione-esami')
            .then((r) => setAttiva(r.data.data.attiva === true))
            .catch(() => setAttiva(null));
    }, []);

    const cambia = async (valore) => {
        setInCorso(true);
        try {
            const r = await api.put('/medici/mia-estrazione-esami', { attiva: valore });
            setAttiva(r.data.data.attiva === true);
        } catch (e) {
            notificaErrore(messaggioDa(e, 'Non sono riuscito a cambiare l\'opzione'));
        } finally {
            setInCorso(false);
        }
    };

    if (attiva === null) return null;
    return (
        <section className="prof-riquadro">
            <h2 className="prof-titolo">Estrazione automatica degli esami</h2>
            <p className="prof-spiega">
                Accesa, un referto di laboratorio caricato per te viene letto da solo e i valori
                compaiono nella tabella degli esami come «da verificare». Nessun valore si conferma
                senza di te.
            </p>
            <label className="checkbox-label">
                <input type="checkbox" checked={attiva} disabled={inCorso}
                       onChange={(e) => cambia(e.target.checked)} />
                <span>{attiva ? 'Accesa' : 'Spenta'}</span>
            </label>
        </section>
    );
};

export default MiaEstrazioneEsami;
